import { useMutation } from '@hooks/reactQuery';

import { getNetworkElementsCheckName } from '@api/networkElements';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { TIdName } from '@interfaces/common/common';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { EErrorCodes } from '@enums/errorCodes';

import { NETWORK_ELEMENTS_CHECK_NAME } from '@constants/queryKeys';

interface IUseMutateNetworkElementsCheckNameReturned {
	handleCheckName: (dto: TIdName) => void;
	isLoadingCheckName: boolean;
}

const useMutateNetworkElementsCheckName = (): IUseMutateNetworkElementsCheckNameReturned => {
	const {
		mutateAsync,
		isLoading,
	} = useMutation<TIdName>({
		mutationKey: [NETWORK_ELEMENTS_CHECK_NAME],
		mutationFn: getNetworkElementsCheckName,
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => (
				item.code === EErrorCodes.uniqueName ||
				item.code === EErrorCodes.notValidNameLength
			))) {
				handleErrorFromMessage(err);
			}
		},
	});

	return {
		handleCheckName: mutateAsync,
		isLoadingCheckName: isLoading,
	};
};

export default useMutateNetworkElementsCheckName;
